import { Add, Close, Delete } from "@mui/icons-material";
import { Box, Button, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React from "react";
import useAuthGlobal from "src/context/useAuthGlobal";
import usePModelDetail from "src/hooks/product/usePModelDetail";
import useWarehouseDetailDistribution from "src/hooks/warehouse/useWarehouseDetailDistribution";

const childWarehouseTemp = {
  childWarehouse: "",
  percentage: "",
};

export default function BalanceWarehousePMCreate({ i, distribution, setDistribution, productId }) {
  const { userMe } = useAuthGlobal();
  const { data: productModel } = usePModelDetail({ id: productId });
  const { data: warehouseDetail } = useWarehouseDetailDistribution({
    id: productModel ? userMe?.currentWarehouse?._id : undefined,
    include: "AllChildren",
    productModel: distribution[0]?.productModel,
  });

  const handleRemoveProductModel = (i) => {
    setDistribution((prev) => prev?.filter((_, index) => index !== i));
  };

  const handleAddMoreChildWarehouse = (i) => {
    const distributionArr = [...distribution];
    distributionArr[i] = { ...distributionArr[i], childWarehouses: [...distributionArr[i]?.childWarehouses, childWarehouseTemp] };
    setDistribution(distributionArr);
  };

  const handleRemoveChildWarehouse = (i, idx) => {
    const distributionArr = [...distribution];
    distributionArr[i] = { ...distributionArr[i], childWarehouses: distributionArr[i]?.childWarehouses?.filter((_, index) => index !== idx) };
    setDistribution(distributionArr);
  };

  const handleDistribution = (name, value, index) => {
    const temp = [...distribution];
    temp[index] = { ...temp[index], [name]: value };
    setDistribution(temp);
  };

  return (
    <Box>
      {i !== 0 && (
        <IconButton
          onClick={() => handleRemoveProductModel(i)}
          sx={{ background: "var(--grey)", width: "15px !important", height: "15px", ml: "auto", display: "flex" }}
        >
          <Close sx={{ fontSize: "14px" }} />
        </IconButton>
      )}

      <FormControl
        fullWidth
        size="small"
        sx={{ my: 2 }}
      >
        <InputLabel id="demo-simple-select-label">Phân loại sản phẩm</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={distribution[i]?.productModel}
          label="Phân loại sản phẩm"
          onChange={(e) => handleDistribution("productModel", e.target.value, i)}
        >
          {Array.isArray(productModel?.data) ? (
            productModel?.data?.map((v) => {
              const isSelected = distribution.some((item, idx) => item.productModel === v._id && idx !== i);
              return (
                <MenuItem
                  disabled={isSelected}
                  key={v?._id}
                  value={v?._id}
                >
                  {v?.name ?? "-"}
                </MenuItem>
              );
            })
          ) : (
            <MenuItem value={undefined}>Không có dữ liệu</MenuItem>
          )}
        </Select>
      </FormControl>
      {distribution[i]?.childWarehouses?.map((_, index) => {
        const total = distribution[i]?.childWarehouses?.reduce((sum, item) => sum + Number(item.percentage || 0), 0) ?? 0;
        return (
          <Box
            key={index}
            display="flex"
            gap={2}
            mt={index !== 0 ? 1 : 0}
            alignItems="flex-start"
            mb={2}
          >
            <FormControl
              fullWidth
              size="small"
            >
              <InputLabel>Kho con</InputLabel>

              <Select
                label="Kho con"
                value={distribution[i]?.childWarehouses[index]?.childWarehouse?._id ?? ""}
                onChange={(e) => {
                  const selected = warehouseDetail?.data?.[0]?.productModels?.[0]?.childWarehouses?.find((v) => v.childWarehouse._id === e.target.value);

                  const item = [...distribution[i].childWarehouses];

                  item[index] = {
                    ...item[index],
                    childWarehouse: selected?.childWarehouse ?? null,
                  };

                  handleDistribution("childWarehouses", item, i);
                }}
              >
                {Array.isArray(warehouseDetail?.data?.[0]?.productModels?.[0]?.childWarehouses) ? (
                  warehouseDetail.data[0].productModels[0].childWarehouses.map((v) => {
                    const isSelected = distribution[i].childWarehouses.some((item, idx) => item.childWarehouse?._id === v.childWarehouse._id && idx !== index);

                    return (
                      <MenuItem
                        key={v.childWarehouse._id}
                        value={v.childWarehouse._id}
                        disabled={isSelected}
                      >
                        {v.childWarehouse.name}
                        {` (Tỷ lệ hiện tại: ${v.percentage}%)`}
                      </MenuItem>
                    );
                  })
                ) : (
                  <MenuItem disabled>Không có kho con trực thuộc</MenuItem>
                )}
              </Select>
            </FormControl>
            <TextField
              error={distribution[i]?.childWarehouses[index]?.percentage > 100 || total > 100}
              label="Tỷ lệ phần trăm"
              fullWidth
              size="small"
              type="number"
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
              value={distribution[i]?.childWarehouses[index]?.percentage ?? 0}
              helperText={total > 100 || distribution[i]?.childWarehouses[index]?.percentage > 100 ? "Vượt quá dung tích cho phép" : ""}
              onChange={(e) => {
                const item = [...distribution[i]?.childWarehouses];
                item[index] = { ...item[index], percentage: Number(e.target.value) };
                handleDistribution("childWarehouses", item, i);
              }}
            />
            <IconButton
              disabled={index === 0 && distribution[i]?.childWarehouses?.length === 1}
              variant="outlined"
              onClick={() => handleRemoveChildWarehouse(i, index)}
            >
              <Delete />
            </IconButton>
          </Box>
        );
      })}
      <Button
        disabled={warehouseDetail?.data?.children?.length === distribution[i]?.childWarehouses?.length}
        onClick={() => handleAddMoreChildWarehouse(i)}
        startIcon={<Add />}
        variant="outlined"
        sx={{ borderRadius: "100px", mt: 2, mx: "auto", display: "flex", justifyContent: "center" }}
      >
        Phân bổ thêm kho
      </Button>
    </Box>
  );
}
